__webpack_require__.p = "/web-tools-assets/_next/";